// import { ReactComponent as BgShapes } from "../imgComponents/bg-shapes.svg";
import "../../css/inner-page/sectionDownloads.scss";
import CTA from "../CTA";
import { ReactComponent as Download } from "../imgComponents/downloads.svg";

export default function Section(props) {
  const ypSellers = (typeof window.Cookies !== "undefined" && window.Cookies.get("_yp_seller")) || false;

  return (
    <section id="downloads">
      <div className="wrapper">
        <div className="downloads-wrapper">
          <div data-aos="fade-up">
            <div className="download-bg">
              <Download />
            </div>
            <div>
              <h2 dangerouslySetInnerHTML={{ __html: props.download.title }}></h2>
              <p>{props.download.content}</p>
            </div>

            <CTA
              href={props.download.file}
              title="Get it now"
              icon="download"
              download
              segmentLocation="Download calendar"
              segmentBtnName="SMS calendar"
            />
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <div className="download-bg">
              <Download />
            </div>
            <div>
              <h2 dangerouslySetInnerHTML={{ __html: props.download_2_download.title }}></h2>
              <p>{props.download_2_download.content}</p>
            </div>
            <CTA
              href={props.download_2_download.file}
              title="Tick those boxes"
              icon="download"
              download
              segmentLocation="Download checklist"
              segmentBtnName="SMS checklist"
            />
          </div>
        </div>

        <div className="resource">
          <div>
            <h3>{props.resource.title}</h3>
            <h4 data-aos="fade-up" dangerouslySetInnerHTML={{ __html: props.resource.subtitle }}></h4>
          </div>
          <CTA
            href={props.resource.cta.url}
            title={props.resource.cta.title}
            icon="arrow-right"
            segmentLocation="SMS resources"
            segmentBtnName="BFCM smsbump"
          />
        </div>
        {(typeof window.isVb !== "undefined" && window.isVb) || ypSellers ? (
          <div style={{ marginTop: "150px" }}></div>
        ) : (
          ""
        )}
        {/* <div className="shapes-bg">
          <BgShapes />
        </div> */}
      </div>
    </section>
  );
}
